import { Button, Loader, Stack, Text, Title } from "@mantine/core";
import { createRoute, Link, useNavigate } from "@tanstack/react-router";

import { useListBrands, useListMyTeams } from "../api/generated/endpoints/teams/teams";
import { NewBrand } from "../features/brands/BrandFormScreens";
import { NewTeam } from "../features/teams/NewTeamScreen";
import { ErrorAlert } from "../platform/ErrorAlert";
import { firstAdChoice, firstAdSearch } from "../platform/first-ad-choice";
import { signedInRoute, teamRoute } from "../platform/routes";

export const firstAdWorkspaceRoute = createRoute({
  getParentRoute: () => signedInRoute, path: "/start/free/create",
  staticData: { ownFrame: true }, validateSearch: (search) => firstAdSearch.parse(search),
  component: Workspace,
});
export const firstAdSetupRoute = createRoute({
  getParentRoute: () => teamRoute, path: "/first-ad/setup", staticData: { ownFrame: true },
  validateSearch: (search) => firstAdSearch.parse(search), component: Setup,
});
function Workspace() {
  const choice = firstAdChoice(firstAdWorkspaceRoute.useSearch());
  const teams = useListMyTeams();
  const navigate = useNavigate();
  if (!choice) return <Link to="/start/free">Choose your ad style</Link>;
  const select = (teamId: string) => navigate({ to: "/teams/$teamId/first-ad/setup", params: { teamId }, search: choice });
  return <Stack p="xl" maw={700} mx="auto" aria-label="First ad workspace">
    <Title order={1}>Your ad workspace</Title>
    <Text>Choose a team for your product, or create your own.</Text>
    {teams.isPending ? <Loader aria-label="Loading teams" /> : null}
    {teams.error ? <ErrorAlert error={teams.error} /> : null}
    {teams.data?.map((team) => <Button variant="default" key={team.id} onClick={() => void select(team.id)}>{team.name}</Button>)}
    <NewTeam onCreated={select} />
  </Stack>;
}
function Setup() {
  const { teamId } = firstAdSetupRoute.useParams();
  const choice = firstAdChoice(firstAdSetupRoute.useSearch());
  const brands = useListBrands(teamId);
  const navigate = useNavigate();
  if (!choice) return <Link to="/start/free">Choose your ad style</Link>;
  const select = (brandId: string) => navigate({ to: "/teams/$teamId/brands/$brandId/first-ad/$templateId",
    params: { teamId, brandId, templateId: choice.template }, search: choice });
  return <Stack p="xl" maw={900} mx="auto" aria-label="First ad brand">
    <Title order={1}>Your product's brand</Title>
    {brands.isPending ? <Loader aria-label="Loading brands" /> : null}
    {brands.error ? <ErrorAlert error={brands.error} /> : null}
    {brands.data?.map((brand) => <Button variant="default" key={brand.id} onClick={() => void select(brand.id)}>{brand.name}</Button>)}
    <NewBrand teamId={teamId} back={(props) => <Link {...props} to="/start/free/create" search={choice} />} onCreated={select} />
  </Stack>;
}
